import React, { HTMLAttributes } from 'react';

import clsx from 'clsx';
import { Spinner } from 'react-bootstrap';

export enum LoaderVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Success = 'success',
  Danger = 'danger',
  Warning = 'warning',
  Info = 'info',
  Light = 'light',
  Dark = 'dark',
}

export enum LoaderSize {
  Small = 'sm',
  Large = 'lg',
}

interface IPohLoaderProps extends HTMLAttributes<HTMLSpanElement> {
  value?: number;
  label?: React.ReactNode;
  variant?: LoaderVariant;
  size?: LoaderSize;
}

const PohLoader: React.FC<IPohLoaderProps> = ({
  value,
  label,
  variant = LoaderVariant.Light,
  size = LoaderSize.Small,
  className,
  ...props
}) => {
  if (value) {
    const width = size === LoaderSize.Large ? 36 : 18;
    const border = size === LoaderSize.Large ? 4 : 6;

    return (
      <svg
        width={`${width}px`}
        height={`${width}px`}
        viewBox="0 0 42 42"
        className={clsx(className, variant && `text-${variant}`)}
      >
        <circle cx="21" cy="21" r="15.91549430918954" fill="transparent" />
        <circle
          className="donut-ring"
          cx="21"
          cy="21"
          r="15.91549430918954"
          fill="transparent"
          stroke="#e9ecef"
          strokeWidth={`${border}px`}
        />

        <circle
          className="donut-segment"
          cx="21"
          cy="21"
          r="15.91549430918954"
          fill="transparent"
          stroke="currentColor"
          strokeWidth={`${border}px`}
          strokeDasharray={`${value} ${100 - value}`}
          strokeDashoffset="0"
        />
        {label && (
          <text
            id="count"
            x="50%"
            y="50%"
            fill="currentColor"
            textAnchor="middle"
            dy="5"
            fontSize="14"
          >
            {label}
          </text>
        )}
      </svg>
    );
  }
  return (
    <Spinner
      as="span"
      size={size as any}
      variant={variant}
      animation="border"
      className={className}
      {...props}
    />
  );
};

export default PohLoader;
